import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import SectionContainer from 'components/section/SectionContainer';
import { SectionPage } from 'components/section/SectionPage';
import EpRolesView from 'components/user-settings/EpRolesView';
import MandatesView from 'components/user-settings/MandatesView';
import MedIndexView from 'components/user-settings/MedIndexView';
import RolesView from 'components/user-settings/RolesView';
import TenantConfigView from 'components/user-settings/TenantConfigView';
import TenantsView from 'components/user-settings/TenantsView';
import UsersView from 'components/user-settings/UsersView';
import React from 'react';

interface Props extends AuthConsumerRenderProps {

}

const UserSettingsHome = (props: Props) => {
  const pages: SectionPage[] = [
    {id: "mandates", uri: "/user-settings/mandates", component: MandatesView}
  ];

  const userRoles = props.currentUser ? props.currentUser.roles : [];
  const isMandateAdmin = userRoles.includes("ROLE_MANDATE_ADMIN");
  const isAppAdmin = userRoles.includes("ROLE_APP_ADMIN");
  const isSysAdmin = userRoles.includes("ROLE_SYSTEM_ADMIN");


  if (isSysAdmin) {
    pages.push({id: "tenant", uri: "/user-settings/tenants", component: TenantsView});
  }

  if (isMandateAdmin || isAppAdmin) {
    pages.push({id: "users", uri: "/user-settings/users", component: UsersView});
    pages.push({id: "roles", uri: "/user-settings/roles", component: RolesView});
    pages.push({id: "epRoles", uri: "/user-settings/ep-roles", component: EpRolesView});
  }

  if (isSysAdmin) {
    pages.push({id: "tenantConfig", uri: "/user-settings/tenant-config", component: TenantConfigView});
    pages.push({id: "medIndex", uri: "/user-settings/medindex", component: MedIndexView});
  }

  return (
      <SectionContainer sectionPages={pages}/>
  );
};

export default withAuthContext(UserSettingsHome);
